import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { SeoLink, ALWAYS_LINKABLE_LINK } from 'dibs-elements/exports/SeoLink';
import { StarRating } from 'dibs-elements/exports/StarRating';

import styles from './GridHeader.scss';

type Props = {
    title: ReactNode;
    rating?: number;
    href: string;
    dataTn: string;
};
export const GridHeader: FC<Props> = ({ title, rating, href, dataTn }) => (
    <div className={styles.wrapper}>
        <div className={styles.header}>
            {title}
            <SeoLink
                className={styles.link}
                variant={ALWAYS_LINKABLE_LINK}
                linkData={{ path: href, isLinkable: false }}
                dataTn={dataTn}
            >
                <FormattedMessage id="GridHeader.viewAll" defaultMessage="View All" />
            </SeoLink>
        </div>
        {rating && (
            <div className={styles.starRating}>
                <div className={styles.ratingValue}>{rating.toFixed(1)}</div>
                <StarRating rating={rating} size="smaller" />
            </div>
        )}
    </div>
);
